import { router } from 'expo-router';

import FullScreenError from './FullScreenError';

const NotFound = () => {
    return (
        <FullScreenError
            message="Oops! We couldn't find that page."
            buttonLabel={router.canGoBack() ? 'Go back' : 'Go home'}
        />
    );
};

export default NotFound;
